import { render, staticRenderFns } from "./Section2.vue?vue&type=template&id=50706240&scoped=true"
import script from "./Section2.vue?vue&type=script&lang=js"
export * from "./Section2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50706240",
  null
  
)

export default component.exports